var map = {
	"./ar.json": 84013,
	"./bn.json": 36769,
	"./bo.json": 73570,
	"./de.json": 26690,
	"./en.json": 40714,
	"./es.json": 11273,
	"./es_419.json": 18875,
	"./es_CU.json": 35507,
	"./fa.json": 17906,
	"./fa_AF.json": 27069,
	"./fi.json": 77936,
	"./fr.json": 89577,
	"./ga.json": 80858,
	"./it.json": 14435,
	"./km.json": 60722,
	"./ku.json": 55334,
	"./lo.json": 46513,
	"./my.json": 65832,
	"./nb_NO.json": 89092,
	"./ps.json": 55211,
	"./pt_BR.json": 55654,
	"./pt_PT.json": 61679,
	"./ro.json": 12412,
	"./ru.json": 7412,
	"./si.json": 65993,
	"./tr.json": 35459,
	"./ug.json": 65703,
	"./zh_Hans.json": 68455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22380;